module.exports = __webpack_public_path__ + "static/media/boutique.554ad787.jpg";